import { FlowService } from 'services/flow.service';
import { FlowConfig } from 'dto/FlowConfig';
import { Router } from '@angular/router';
import { LocaleService } from 'angular-l10n';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ResourcesEditorComponent } from "app/resources-editor/resources-editor.component";

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent implements OnInit
{
    selectedFlowId = null;
    availableLanguages:Array<string>;
    appLanguage:string;

    constructor(private router: Router, private modalService:NgbModal, private locale:LocaleService, private flowService:FlowService) {
        this.flowService.FlowChange.subscribe(flowId => this.selectedFlowId = flowId);
    }

    ngOnInit()
    {
        this.appLanguage = this.locale.getCurrentLocale();
        this.availableLanguages = this.locale.getAvailableLanguages();
    }
  
    languageChange()
    {
        this.locale.setCurrentLanguage(this.appLanguage);
    }
  
    openFlow(flowId:string): void
    {
        this.router.navigate(['/fetch-data',flowId]);
    }

    openResources() {
        const modalRef = this.modalService.open(ResourcesEditorComponent, {size: 'lg'});
        modalRef.result.then( fulfilled => {}, rejected => {} );
    }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/navmenu/navmenu.component.ts